import React, { useState, useMemo, useRef, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import Split from "react-split";

const InputArea = ({ text, onChange }) => {
  const inputFileRef = useRef(null);

  const uploadFile = async (e) => {
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = async ({ target: { result } }) => onChange(result);
    reader.readAsText(e.target.files[0]);
  };

  return (
    <div className="position-relative h-100">
      <textarea
        className="form-control h-100"
        value={text}
        onChange={({ target: { value } }) => onChange(value)}
      ></textarea>
      <button
        href="#"
        className="btn btn-primary position-absolute"
        style={{ bottom: ".5em", right: "1.5em" }}
        data-bs-toggle="popover"
        data-bs-content="Copied!"
        data-bs-placement="bottom"
        onClick={() => inputFileRef.current.click()}
      >
        <i className="fa fa-lg fa-upload text-light">
          <input
            type="file"
            id="file"
            ref={inputFileRef}
            onChange={async (e) => await uploadFile(e)}
            style={{ display: "none" }}
          />
        </i>
      </button>
    </div>
  );
};

const ResultsArea = ({ converted, swapUrl }) => {
  return (
    <div className="position-relative h-100">
      <textarea
        className="form-control h-100"
        readOnly
        value={converted}
      ></textarea>
      {swapUrl && (
        <button
          href="#"
          className="btn btn-primary position-absolute"
          style={{ top: ".5em", right: "1.5em" }}
          data-bs-toggle="popover"
          data-bs-content="Copied!"
          data-bs-placement="bottom"
          onClick={() => {
            localStorage.swapDecodeText = converted;
            window.location.href = swapUrl;
          }}
        >
          <i className="fa fa-lg fa-exchange text-light"></i>
        </button>
      )}
      <button
        href="#"
        className="btn btn-primary position-absolute"
        style={{ bottom: ".5em", right: "1.5em" }}
        data-bs-toggle="popover"
        data-bs-content="Copied!"
        data-bs-placement="bottom"
        onClick={() => {
          navigator.clipboard.writeText(converted);
        }}
      >
        <i className="fa fa-lg fa-copy text-light"></i>
      </button>
    </div>
  );
};

const MobileView = ({ text, converted, onChange, swapUrl }) => {
  return (
    <div className="d-flex flex-column flex-grow-1 h-100">
      <div className="flex-grow-1">
        <InputArea text={text} onChange={onChange} />
      </div>
      <div className="flex-grow-1 pt-2">
        <ResultsArea converted={converted} swapUrl={swapUrl} />
      </div>
    </div>
  );
};
const DesktopView = ({ text, converted, onChange, swapUrl }) => {
  return (
    <Split className="d-flex flex-row flex-grow-1">
      <InputArea text={text} onChange={onChange} />
      <ResultsArea converted={converted} swapUrl={swapUrl} />
    </Split>
  );
};

const EncodeDecodeView = ({ onEncode, swapUrl }) => {
  const [text, setText] = useState(localStorage.swapDecodeText || ``);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const converted = useMemo(() => onEncode(text), [text]);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  useEffect(() => (localStorage.swapDecodeText = ""));

  return (
    <div className="d-flex flex-column flex-grow-1 p-1">
      {isMobile ? (
        <MobileView
          text={text}
          converted={converted}
          swapUrl={swapUrl}
          onChange={setText}
        />
      ) : (
        <DesktopView
          text={text}
          converted={converted}
          swapUrl={swapUrl}
          onChange={setText}
        />
      )}
    </div>
  );
};

export default EncodeDecodeView;
